import AppSettings from '../configs/appSettings';
import Constants from '../helpers/Constants';
import { Criteria, Document, DocumentMenuBranch } from '../models/document';
import apiService from './ApiService';

export async function getProductManuals({
  sku,
  page,
  sortMethod
}: {
  sku: string;
  page: number;
  sortMethod: number;
}): Promise<Document> {
  const url = `${Constants.ApiPath.DocumentPage}/product-manuals`;
  const response = await apiService.get(url, { sku, page, sortMethod });

  return response.data;
}

export async function generateDocument(fileIds: string[], category?: string): Promise<string> {
  const url = Constants.ApiPath.DocumentGenerate;
  const response = await apiService.get(url, {
    ids: fileIds,
    category: category,
    Accept: 'text/plain',
  });

  return response.data;
}

export async function getDocumentDownloadUrl(
  fileIds: string[],
  category?: string
): Promise<string> {
  const code = await generateDocument(fileIds, category);
  const url = `${AppSettings.ApiBaseUrl}/${
    Constants.ApiPath.DocumentDownload
  }?code=${encodeURIComponent(code)}`;

  return url;
}

export async function getDocumentMenuItems(): Promise<DocumentMenuBranch[]> {
  const response=await apiService.get("api/documents/menu/");
   
  return response.data;
}
